

const defaultTimeRange = {
  Hourly: 'LastMonth',
  HourOfDay: 'LastMonth',
  Daily: 'LastMonth',
  DayOfWeek: 'LastMonth',
  Weekly: 'LastMonth',
  Monthly: 'LastMonth',
  Yearly: 'ThisYear',
  Summary: 'LastMonth',
  AllTime: 'AllTime',
};

export const getDefaultTimeRange = (timeGrain, reportSchema, isAllTime) => {
  if (isAllTime) {
    return defaultTimeRange.AllTime;
  }
  return reportSchema.TimeRanges ? reportSchema.TimeRanges[timeGrain][0] : defaultTimeRange[timeGrain];
};
